import { marketingAllowed, MARKETING_EXCLUDED_KEY } from "./marketingPrivacy";

let permitted = false;
let pixelId = null;
let loading = null;
const sent = new Set();

function allowed() {
  try {
    return permitted && marketingAllowed()
      && localStorage.getItem(MARKETING_EXCLUDED_KEY) !== "1"
      && !document.cookie.split(";").some(c => c.trim().startsWith("impersonator_ctx="))
      && ["/", "/creators"].includes(window.location.pathname);
  } catch { return false; }
}

function load() {
  if (loading) return loading;
  // Meta's queue bootstrap. Load only when the site's tracking policy allows it.
  if (!window.fbq) {
    const fbq = function () {
      if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
      else fbq.queue.push(arguments);
    };
    fbq.push = fbq; fbq.loaded = true; fbq.version = "2.0"; fbq.queue = [];
    window.fbq = fbq;
    if (!window._fbq) window._fbq = fbq;
  }
  window.fbq.disablePushState = true;
  window.fbq("consent", "revoke");
  window.fbq("set", "autoConfig", false, pixelId);
  window.fbq("init", pixelId);
  loading = new Promise(resolve => {
    const script = document.createElement("script");
    script.id = "ytmethod-meta-pixel";
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    const timer = setTimeout(() => resolve(false), 8000);
    script.onload = () => { clearTimeout(timer); resolve(true); };
    script.onerror = () => { clearTimeout(timer); resolve(false); };
    document.head.appendChild(script);
  });
  return loading;
}

export function syncMetaPixel(id, enabled) {
  permitted = enabled === true && /^\d{5,30}$/.test(String(id || ""));
  // Refusal/internal navigation also revokes a script loaded on a previous page.
  if (!allowed()) {
    if (window.fbq) window.fbq("consent", "revoke");
    return;
  }
  if (pixelId && pixelId !== id) return; // A page never initializes a second pixel.
  pixelId = id;
  load().then(ready => { if (ready && allowed()) window.fbq("consent", "grant"); });
}

export async function trackMetaPageView(visitId, path) {
  try {
    if (!allowed() || !pixelId || !loading) return false;
    // Same identity as backend/meta_conversions.py event_payload("PageView", visitId).
    const digest = await window.crypto.subtle.digest("SHA-256", new TextEncoder().encode("PageView:" + visitId));
    const eventID = Array.from(new Uint8Array(digest), b => b.toString(16).padStart(2, "0")).join("");
    if (!await loading || !allowed() || window.location.pathname !== path || sent.has(eventID)) return false;
    window.fbq("consent", "grant");
    window.fbq("trackSingle", pixelId, "PageView", {}, { eventID });
    sent.add(eventID);
    return true;
  } catch { return false; } // Blockers/unsupported browsers never affect the app or CAPI.
}
